export default __webpack_public_path__ + "static/media/nav-logo.4eade44d.svg";